// src/api/providers.js

export async function getProviderPrice(ticker) {
  const response = await fetch(`/providers/price?ticker=${encodeURIComponent(ticker)}`);
  if (!response.ok) throw new Error("Failed to fetch price");
  return await response.json();
}

export async function getProviderFundamentals(ticker) {
  const response = await fetch(`/providers/fundamentals?ticker=${encodeURIComponent(ticker)}`);
  if (!response.ok) throw new Error("Failed to fetch fundamentals");
  return await response.json();
}

export async function getProviderNews(ticker) {
  const response = await fetch(`/providers/news?ticker=${encodeURIComponent(ticker)}`);
  if (!response.ok) throw new Error("Failed to fetch news");
  return await response.json();
}
